import { render, staticRenderFns } from "./DepositsList.vue?vue&type=template&id=1f79cc07&scoped=true&"
import script from "./DepositsList.vue?vue&type=script&lang=js&"
export * from "./DepositsList.vue?vue&type=script&lang=js&"
import style0 from "./DepositsList.vue?vue&type=style&index=0&id=1f79cc07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f79cc07",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VIcon,VTooltip})
